import React from 'react'
import { Box, Grid } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: 35,
    maxWidth: 1280,
    width: '100%',
    // marginBottom: 50,
    color: '#002f3d',
    backgroundColor: '#FFF'
  },
  homePageHeader: {
    fontSize: 28,
    fontWeight: 400,
    marginTop: 20,
    marginLeft: 10,
    textAlign: 'center'
  },
  titleItemContainer: {
    margin: '15px 10px'
  },
  titleImageContainer: {
    height: 230,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  },
  titleTextContainer: {
    padding: '10px 20px',
    background: 'white'
  },
  titleText: {
    display: 'block',
    fontWeight: 500,
    fontSize: 24,
    lineHeight: '32px'
  },
  subTitleText: {
    display: 'block',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '24px'
  }
}))

const MiddlePart = () => {
  const classes = useStyles()

  const { middlePartBody1, middlePartBody2, middlePartTitle } = useSelector(
    (state) => state.language.text
  )

  return (
    <>
      <Grid container justify="center" spacing={0}>
        <Grid item className={classes.container}>
          <Grid item xs={12} className={classes.homePageHeader}>
            {middlePartTitle}
          </Grid>

          <Grid item xs={12}>
            <Box className={classes.titleItemContainer}>
              <Box className={classes.titleTextContainer}>
                <span className={classes.subTitleText}>{middlePartBody1}</span>
              </Box>
              <Box className={classes.titleTextContainer}>
                <span className={classes.subTitleText}>{middlePartBody2}</span>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default MiddlePart
